import { observer } from "mobx-react";
import React from "react";
// import RootStore from "SandboxViewerComponent/src/stores/RootStore";
import { Slider } from "@mui/material";

const ForecastToggle = (props) => {
  const {
    CommunicationStore,
    attributeId,
    nls = {
      minimum: "Min",
      maximum: "Max",
      mittel: "Mittel",
      calculating: "Berechne Mittelwerte ...",
    },
    compact,
  } = props;

  // const mobile = RootStore.uiStore.BBStore.mobile;

  // const {
  //   current: zeitraum = null,
  //   szenario = null,
  //   allSzenarios = [],
  // } = getTimespansFromCommunicationStore(CommunicationStore);

  const {
    items = [],
    index,
    setIndex = () => {},
  } = CommunicationStore.getMessagesToID({ to: "filterAccess" })?.message(
    attributeId
  ) || {};
  const tmap = {};
  const hasValidItems = items.length > 1;

  if (hasValidItems) {
    for (let i = 0; i < items.length; i++) {
      const lab = `${items[i].label}`.toLowerCase();
      if (lab === "mittel") tmap.avg = i;
      else if (lab === "minimum") tmap.min = i;
      else if (lab === "maximum") tmap.max = i;
    }
  }

  const isEnabled = !!hasValidItems;

  const setLayer = (which) => {
    let index = 0;
    if (tmap[which] !== undefined) index = tmap[which];
    setIndex(index);
  };

  let current = "avg";
  if (index === tmap["avg"]) current = "avg";
  else if (index === tmap["min"]) current = "min";
  else if (index === tmap["max"]) current = "max";

  const sliderValue = current === "max" ? 2 : current === "min" ? 0 : 1;
  const thumbColor =
    current === "max" ? "#d1003c" : current === "avg" ? "#f97316" : "#0042d1";

  return (
    <>
      {/* {mobile && (
        <div
          style={{ display: "flex", alignItems: "center", gap: 8, padding: 4 }}
        >
          <Select
            style={{ height: 30, fontSize: "0.8em", flex: 1 }}
            variant="outlined"
            disabled={!isEnabled}
            onChange={(ev) => {
              const { value } = ev.target;
              if (value && isEnabled) setLayer(value);
            }}
            value={current || ""}
          >
            <MenuItem value={"max"}>{`${nls.maximum}`}</MenuItem>
            <MenuItem value={"avg"}>{`${nls.mittel}`}</MenuItem>
            <MenuItem value={"min"}>{`${nls.minimum}`}</MenuItem>
          </Select>
        </div>
      )} */}

      {/* {!mobile && ( */}
      <Slider
        orientation="vertical"
        min={0}
        max={2}
        step={1}
        marks={[
          { value: 2, label: `${nls.maximum}` },
          { value: 1, label: `${nls.mittel}` },
          { value: 0, label: `${nls.minimum}` },
        ]}
        value={sliderValue}
        onChange={(e, val) => {
          if (isEnabled) {
            const key = val === 2 ? "max" : val === 1 ? "avg" : "min";
            setLayer(key);
          }
        }}
        disabled={!isEnabled}
        aria-label="Forecast slider"
        track={false}
        sx={{
          // opacity: isEnabled ? 1 : 0.5,
          pointerEvents: isEnabled ? "auto" : "none",
          width: 24,
          height: "85%",
          marginRight: 4,
          "& .MuiSlider-rail": {
            background:
              "linear-gradient(180deg, #e50042 0%, #f97316 40%, #f97316 55%, #3b82f6 78%, #0042d1 90%)",
            opacity: 1,
            borderRadius: 4,
            width: compact ? 4 : 8,
          },
          "& .MuiSlider-track": { background: "transparent" },
          "& .MuiSlider-thumb": {
            width: compact ? 8 : 16,
            height: compact ? 8 : 16,
            border: `2px solid ${thumbColor}`,
            background: thumbColor,
            boxShadow: "0 3px 8px rgba(0,0,0,0.12)",
          },
          "& .MuiSlider-markLabel": {
            fontSize: compact ? "0.6em" : "0.72rem",
            whiteSpace: "nowrap",
            color: "#334155",
          },
          "& .MuiSlider-mark": {
            opacity: 1,
            width: compact ? 5 : 10,
            height: compact ? 2 : 4,
            background: "#ffffff",
            borderRadius: 2,
            border: "1px solid #cbd5e1",
          },
        }}
      />
      {/* )} */}
    </>
  );
};

export default observer(ForecastToggle);
